import React from "react";

import Logo from "@assets/logo/logo-dnk.svg?react";
import LogoSmall from "@assets/logo/logo-dnk-collapsed.svg?react";
import IconCollapse from "@assets/icons/collapse.svg?react";
import IconExpand from "@assets/icons/expand.svg?react";
import IconHome from "@assets/icons/icon-home.svg?react";
import IconRadar from "@assets/icons/icon-radar.svg?react";
import IconLocation from "@assets/icons/icon-location.svg?react";
import IconVessel from "@assets/icons/icon-vessel.svg?react";
import IconInvoice from "@assets/icons/icon-invoice.svg?react";
import IconUpdateRequest from "@assets/icons/icon-update-request.svg?react";
import IconOrganisation from "@assets/icons/icon-organisation.svg?react";
import IconUser from "@assets/icons/icon-user.svg?react";
import IconCyberRisk from "@assets/icons/icon-cyber.svg?react";
import IconInfo from "@assets/icons/icon-info.svg?react";
import NavLink from "./NavLink";
import { useAuth } from "@hooks/useAuth";
import { Permission } from "../Auth/permissions";
import Icon from "../common/Icon";

function Navigation({
	visible = false,
	setVisibility = () => {},
	className = "",
}) {
	const { /*user,*/ checkPermissions } = useAuth();

	const [collapsed, setCollapsed] = React.useState(() => {
		return false;
	});
	const toggleCollapse = (evt) => {
		evt.preventDefault();
		setCollapsed((c) => !c);
	};
	const close = () => {
		if (visible) setVisibility(false);
	};
	const collapseOnDesktop = () => {
		if (
			!collapsed &&
			typeof window !== "undefined" &&
			window.innerWidth >= 768
		) {
			setCollapsed(true);
		}
		close();
	};

	return (
		<>
			<nav
				aria-label="main"
				className={`absolute transition-all top-0 bottom-0 md:relative z-[149] bg-the-blue flex flex-col text-white ${
					collapsed ? "w-16 md:w-24" : "w-50 md:w-72"
				} transition-width duration-300 overflow-x-hidden print:hidden ${visible ? "left-0" : "-left-full md:left-0"} ${className || ""}`}
			>
				<div
					className={`flex items-center overflow-hidden h-10 max-h-10 md:h-auto md:max-h-none ${collapsed ? "justify-center" : "justify-between pr-4"} md:justify-start py-7`}
				>
					<a
						id="website"
						href={WEBSITE_URL}
						className={`${collapsed ? "hidden md:block" : ""} pl-4 md:pl-8 text-white`}
					>
						{!collapsed && (
							<Logo className="w-18 h-6 md:h-9 md:w-auto" />
						)}
						{collapsed && (
							<LogoSmall className="w-6 h-6 md:h-9 md:w-auto" />
						)}
					</a>
					<button
						type="button"
						aria-label="Close navigation"
						className="flex items-center md:hidden"
						onClick={close}
					>
						<Icon name="cyber-close" size="2xl" />
					</button>
				</div>

				<button
					type="button"
					onClick={toggleCollapse}
					className={`appearance-none flex items-center ${collapsed ? "justify-center" : "pl-4"} gap-3 md:gap-0 font-sans-wide text-sm md:text-lg cursor-pointer border-secondary-blue border-y py-7 hover:bg-trans-15`}
				>
					{collapsed && (
						<IconExpand className="text-white mx-auto h-6 w-6 min-w-6 md:h-8 md:w-16 md:min-w-16" />
					)}
					{!collapsed && (
						<>
							<IconCollapse className="text-white h-6 w-6 min-w-6 md:h-8 md:w-16 md:min-w-16" />
							<span>Collapse</span>
						</>
					)}
				</button>

				<div className="flex flex-col whitespace-nowrap">
					<NavLink
						href="/"
						icon={IconHome}
						collapsed={collapsed}
						onClick={collapseOnDesktop}
					>
						Home
					</NavLink>
					{checkPermissions("none", Permission.TRIPADMIN, false) && (
						<>
							<NavLink
								href={`${TRIPADMIN_URL}/map`}
								icon={IconRadar}
								collapsed={collapsed}
								onClick={collapseOnDesktop}
							>
								Map & Threat Areas
							</NavLink>
							<NavLink
								href={TRIPADMIN_URL}
								icon={IconLocation}
								collapsed={collapsed}
								onClick={collapseOnDesktop}
							>
								Trips
							</NavLink>
						</>
					)}
					{checkPermissions("any", [
						Permission.POLICIES_WAR,
						Permission.POLICIES_CYBERRISK,
					]) && (
						<NavLink
							href="/policies"
							icon={IconVessel}
							collapsed={collapsed}
							onClick={collapseOnDesktop}
						>
							Policies
						</NavLink>
					)}
					{checkPermissions("any", [
						Permission.INVOICES_WAR,
						Permission.INVOICES_CYBERRISK,
					]) && (
						<NavLink
							href={"/invoices"}
							icon={IconInvoice}
							collapsed={collapsed}
							onClick={collapseOnDesktop}
						>
							Invoices
						</NavLink>
					)}
					{checkPermissions("any", [
						Permission.UPDATE_REQUESTS_ORGANISATIONS,
						Permission.UPDATE_REQUESTS_POLICIES,
						Permission.UPDATE_REQUESTS_VESSELS,
					]) && (
						<NavLink
							href={"/update_requests"}
							icon={IconUpdateRequest}
							collapsed={collapsed}
							onClick={collapseOnDesktop}
						>
							Update Requests
						</NavLink>
					)}
					<NavLink
						href={"/organisations"}
						icon={IconOrganisation}
						collapsed={collapsed}
						onClick={collapseOnDesktop}
					>
						Organisations
					</NavLink>
					<NavLink
						href={"/cyberrisk"}
						icon={IconCyberRisk}
						collapsed={collapsed}
						onClick={collapseOnDesktop}
					>
						Cyber
					</NavLink>
					{/* {(checkPermissions(
						"any",
						Permission.CLAIMS_CYBERRISK,
						false
					) ||
						(user?.uwr &&
							checkPermissions(
								"none",
								Permission.CLAIMS_HANDLER,
								false
							))) && (
						<NavLink
							href={"/claims"}
							icon={IconCyberRisk}
							collapsed={collapsed}
							onClick={collapseOnDesktop}
						>
							Claims
						</NavLink>
					)} */}
					{checkPermissions("any", Permission.USERS_MANAGEMENT) && (
						<NavLink
							href={"/users"}
							icon={IconUser}
							collapsed={collapsed}
							onClick={collapseOnDesktop}
						>
							Users
						</NavLink>
					)}
					{checkPermissions("none", Permission.CIRCULARS, false) && (
						<NavLink
							href={"/circulars"}
							icon={IconInfo}
							collapsed={collapsed}
							onClick={collapseOnDesktop}
						>
							Circulars & Files
						</NavLink>
					)}
				</div>
			</nav>
		</>
	);
}

export default Navigation;
